import { useState } from 'react';
import { useDispatch } from 'react-redux';
import LoadingButton from 'components/loading_button/loading_button';
import { touchBooking } from 'redux/actions/booking';

export const KeepAliveMessage = () => {
  const dispatch = useDispatch();
  const [touched, setTouched] = useState(false);

  return (
    <div className="space-y-2">
      <div className="text-small text-dark">Your booking will expire soon!</div>
      <LoadingButton
        type="button"
        className="btn btn-sm btn-light"
        disabled={touched}
        loading={touched}
        onClick={() => {
          dispatch(touchBooking());
          setTouched(true);
        }}
      >
        {touched ? 'Extending session...' : 'Extend session'}
      </LoadingButton>
    </div>
  );
};
